module.exports = __webpack_public_path__ + "img/toggle_menu.1ef3f064.png";